import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString } from "vue"

import { useI18n } from 'vue-i18n';

    
export default /*@__PURE__*/_defineComponent({
  __name: 'DataTableMonth',
  props: {
    month: {}
  },
  setup(__props: any) {

    const { t } = useI18n();

    

return (_ctx: any,_cache: any) => {
  return _toDisplayString(_unref(t)(`salary.sheets.months.${_ctx.month}`))
}
}

})